import { useTheme } from "../../framework/theme/mantine-passthroughs.js";
import { IconPerson } from "../icon/variants/IconPerson.js";
import avatar_module_default from "./avatar.module.js";
import { Avatar, Text } from "@mantine/core";
import { forwardRef, useEffect, useState } from "react";
import { jsx } from "react/jsx-runtime";

//#region src/components/avatar/Avatar.tsx
const sizeMap = {
	sm: {
		pixelSize: "2rem",
		fontSize: "sm",
		fontWeight: 400
	},
	md: {
		pixelSize: "2.5rem",
		fontSize: "lg",
		fontWeight: 600
	},
	lg: {
		pixelSize: "3rem",
		fontSize: "xl",
		fontWeight: 600
	},
	xl: {
		pixelSize: "3.5rem",
		fontSize: "xl",
		fontWeight: 600
	}
};
const AvatarContent = ({ AvatarIcon, initials, children, size = "md", color = "primary" }) => {
	const { fontSize, fontWeight, pixelSize } = sizeMap[size];
	if (initials) return /* @__PURE__ */ jsx(Text, {
		size: fontSize,
		fw: fontWeight,
		children: initials
	});
	if (AvatarIcon) return /* @__PURE__ */ jsx(AvatarIcon, {
		color,
		width: `calc(${pixelSize} * 0.6)`,
		height: `calc(${pixelSize} * 0.6)`
	});
	return children;
};
const Avatar$1 = forwardRef(({ size = "md", src, alt, initials, AvatarIcon, color = "primary", children, onClick, "data-testid": testId = "avatar" }, ref) => {
	const [altText, setAltText] = useState(alt);
	const iconColor = useTheme().other.getIconColor(color);
	useEffect(() => {
		if (src === void 0) setAltText(void 0);
	}, [src]);
	return /* @__PURE__ */ jsx(Avatar, {
		src,
		alt: altText,
		size: sizeMap[size].pixelSize,
		"data-testid": testId,
		"data-action": Boolean(onClick),
		imageProps: { onError: () => {
			setAltText(void 0);
		} },
		color: iconColor,
		classNames: avatar_module_default,
		onClick,
		ref,
		children: /* @__PURE__ */ jsx(AvatarContent, {
			AvatarIcon: AvatarIcon ?? IconPerson,
			initials: initials?.slice(0, 2).toUpperCase(),
			size,
			children
		})
	});
});
Avatar$1.displayName = "Avatar";

//#endregion
export { Avatar$1 as Avatar };